import { Validator } from '../../Validator';
import { ValidatorInterface } from '../../ValidatorInterface';
import { ValidatorRegistry } from '../../ValidatorRegistry';
import { PropertiesInterface } from '../Property';
import { ITypeValidatesArrayUnique } from './ITypeValidatesArrayUnique';

export class ArrayUniqueValidator
  implements ValidatorInterface<ITypeValidatesArrayUnique>
{
  name = 'ArrayUnique';

  friendlyName = 'Unique Values';

  arrayOnly = true;

  array = true;

  description = 'Each entry in this list must be unique';

  types = null;

  properties = {
    value: {
      type: 'Boolean',
      default: true,
      validators: [
        {
          name: 'Required',
          value: true,
        },
      ],
    },
  } as PropertiesInterface;

  constructor(public config?: Validator) {}

  attach(type: ITypeValidatesArrayUnique) {
    type.addArrayUniqueValidator(this);
  }
}

const arrayUniqueValidator = new ArrayUniqueValidator(undefined);

ValidatorRegistry.register(ArrayUniqueValidator, arrayUniqueValidator.name);

export { arrayUniqueValidator };
